export const CLOSE_REASON = {
  default: 'Disconnected',
  heartbeatTimeout: 'Heartbeat Timeout',
  reconnect: 'Reconnect',
} as const;
export const closeReasons = Object.values(CLOSE_REASON);
export type CloseReason = typeof closeReasons[number];
